import { Flex } from "@chakra-ui/react";
import Loader from "react-loader-spinner";

export default function Spinner() {
  return (
    <Flex>
      <Loader type="ThreeDots" color="#ff0004" height={40} width={40} ariaLabel="loading" />
    </Flex>
  );
}
